module.exports = __webpack_public_path__ + "img/icon-mingxi.83805e45.png";